import { Card, Text } from '@nike/eds'
import { capitalize, measure, plannedAndActualPackedQuantity } from '../../common/utils/formatter'
import { DetailsField } from '../../common/components/fields/DetailsField'
import { GoodsHolder } from '../../generated/graphql'
import React from 'react'
import './GoodsHolderDetails.scss'

function getPalletNumber(goodsHolder: GoodsHolder) {
  return goodsHolder?.containingGoodsHolderTypeCode === 'PALLET'
    ? goodsHolder?.containingGoodsHolderNumber
    : null
}

export function GoodsHolderDetails({ goodsHolder }) {
  return (
    <div>
      <Text
        as="h2"
        font="title-3"
        style={{ margin: '0 0 var(--eds-space-16) var(--eds-space-12)' }}
        className="vcenter"
      >
        Carton Details
      </Text>
      <Card className="carton-details-fields" padding={12}>
        <div className="flex-row content-space-between">
          <DetailsField label="Tracking Number">
            {goodsHolder.goodsHolderTrackingNumber}
          </DetailsField>
          <DetailsField label="CMR">{goodsHolder.transportHolder?.proNumber}</DetailsField>
          <DetailsField label="# Units (P/A)">
            {plannedAndActualPackedQuantity(goodsHolder)}
          </DetailsField>
          <DetailsField label="Actual Weight">
            {measure(goodsHolder.goodsHolderMeasures?.grossWeight)}
          </DetailsField>
        </div>
        <div className="flex-row content-space-between">
          <DetailsField label="Status">
            {capitalize(goodsHolder.calculatedGoodsHolderStatusCode)}
          </DetailsField>
          <DetailsField label="Trailer Number">
            {goodsHolder.transportHolder?.transportHolderNumber}
          </DetailsField>
          <DetailsField label="Pallet Number">{getPalletNumber(goodsHolder)}</DetailsField>
          <DetailsField label="Actual Volume">
            {measure(goodsHolder.goodsHolderMeasures?.grossVolume)}
          </DetailsField>
        </div>
      </Card>
    </div>
  )
}
